export enum TransferType {
  // PRO-SOLUTO con conferma e notifica
  ProSolutoConfirmNotification = 'ProSolutoConfirmNotification',

  // PRO-SOLUTO senza conferma con notifica
  ProSolutoNoConfirmNotification = 'ProSolutoNoConfirmNotification',

  // PRO-SOLUTO senza conferma e notifica
  ProSolutoNoConfirmNoNotification = 'ProSolutoNoConfirmNoNotification',

  // PRO-SOLVENDO con conferma e notifica
  ProSolvendoConfirmNotification = 'ProSolvendoConfirmNotification',

  // PRO-SOLVENDO senza conferma con notifica
  ProSolvendoNoConfirmNotification = 'ProSolvendoNoConfirmNotification',

  // PRO-SOLVENDO con conferma senza notifica
  ProSolvendoConfirmNoNotification = 'ProSolvendoConfirmNoNotification',

  // PRO-SOLVENDO senza conferma e notifica
  ProSolvendoNoConfirmNoNotification = 'ProSolvendoNoConfirmNoNotification',

  // IAS-Compliant - PRO-SOLUTO con conferma con notifica
  IasProSolutoConfirmNotification = 'IasProSolutoConfirmNotification',

  // IAS-Compliant - PRO-SOLUTO con conferma senza notifica
  IasProSolutoConfirmNoNotification = 'IasProSolutoConfirmNoNotification',

  // IAS PRO-SOLUTO SENZA CONFERMA CON NOTIFICA
  IasProSolutoNoConfirmNotification = 'IasProSolutoNoConfirmNotification',

  // IAS PRO-SOLUTO SENZA CONFERMA SENZA NOTIFICA
  IasProSolutoNoConfirmNoNotification = 'IasProSolutoNoConfirmNoNotification',
}
